<template>
    <div class="d-flex flex-column h-100 overflow-y-scroll position-sticky">
        <IconSearchBar :groups="groups" @update:results="e => results = e"></IconSearchBar>
        <IconSearchResults v-if="results?.icons?.length >= 1 || results?.groups?.length >= 1" :results="results" :activeRisks="risks"></IconSearchResults>
    </div>
</template>

<script>
import IconSearchBar from './IconSearchBar.vue';
import IconSearchResults from './IconSearchResults.vue';


export default {
    components: {
        IconSearchBar,
        IconSearchResults
    },
    props: ['groups', 'risks'],
    data() {
        return {
            results: {
                icons: [],
                groups: [],
                risks: [],
            },
        }
    },

    mounted() {
        document.querySelectorAll('[id^="pills-"][id$="-tab"]')?.forEach(element => {
            element.addEventListener('click', () => {
                if (this.results?.icons?.length >= 1 || this.results?.groups?.length >= 1) {
                    this.results = {
                        icons: [],
                        groups: [],
                        risks: []
                    }
                }
            })
        })
    },

    watch: {
        results: {
            deep: true,
            immediate: true,
            handler: function (val, oldVal) {
                if (this.results?.icons?.length >= 1 || this.results?.groups?.length >= 1) {
                    document.querySelectorAll("[id*='graphic-tools']")?.forEach((element) => {
                        element.classList.add('hidden')
                    })
                } else {
                    document.querySelectorAll("[id*='graphic-tools']")?.forEach((element) => {
                        element.classList.remove('hidden')
                    })
                }
            }
        },
    },
}
</script>
